module.exports = __webpack_public_path__ + "img/N-icon.3d181663.svg";